<template>
  <el-dialog
    :close-on-press-escape="false"
    custom-class="layout-dialog"
    title="カレンダー"
    top="5vh"
    width="900px"
    :visible.sync="dialogVisible"
    append-to-body
    class="el_dialog"
    @close="close"
  >
    <vab-calendar ref="calendar" :change-show="false">
      <div slot="noday"></div>
    </vab-calendar>
    <div slot="footer" class="dialog-footer flex_end mg12">
      <div class="flex_start flex_center_align">
        <vab-button :btn-list="btnList" />
      </div>
    </div>
    <PopupChildren
      :visible2="visibleChildren"
      :list="popChildrenList"
      :visible-children.sync="visibleChildren"
    />
  </el-dialog>
</template>

<script>
  import { calendarSure } from '@/api/rc/scheduleAdjConfirm'
  import { resetCalender, crossDaySet } from '@/utils/index'

  export default {
    name: 'WorkPopupCalender',
    props: {},
    data() {
      return {
        btnListRt: [
          {
            name: ' 各種データダウンロード',
            widht: 'auto',
            icon: 'select',
            type: 'plain',
            hover: '#0071EE',
            word: this.$t(
              `validateMessage.${this.$messageCode.I00000446.name}`
            ),
            defaultColor: '#0060C2',
            hidden: false,
            click: () => {
              this.show()
            },
          },
        ],
        visibleChildren: false,
        dialogVisible: false,
        rulesDay: {},
        open: '2',
        columns: [
          {
            label: '氏名',
            'min-width': 228,
            prop: '',
          },
          {
            label: 'FM社員CD',
            'min-width': 120,
            prop: '',
          },
          {
            label: '職種名称',
            'min-width': 228,
            prop: '',
          },
          {
            label: '休日パターン',
            'min-width': 160,
            prop: '',
          },
          {
            label: '勤務時間',
            'min-width': 120,
            prop: '',
          },
        ],
        btnList: [
          {
            name: 'キャンセル',
            type: 'button',
            hidden: false,
            click: () => {
              this.close()
            },
          },
        ],
        value: '',
        popChildrenList: [
          {
            title: 'PS課→組合',
            buttonList: [
              {
                name: ' 拠点発送レター',
                widht: 'auto',
                type: 'plain',
                hover: '#0071EE',
                word: this.$t(
                  `validateMessage.${this.$messageCode.I00000446.name}`
                ),
                defaultColor: '#0060C2',
                hidden: false,
              },
              {
                name: ' FM封筒',
                widht: 'auto',
                type: 'plain',
                hover: '#0071EE',
                word: this.$t(
                  `validateMessage.${this.$messageCode.I00000446.name}`
                ),
                defaultColor: '#0060C2',
                hidden: false,
              },
            ],
          },
          {
            title: '捺印返送日（返送）',
            buttonList: [
              {
                name: ' 返送レター（協力会社返送分）',
                widht: 'auto',
                type: 'plain',
                hover: '#0071EE',
                word: this.$t(
                  `validateMessage.${this.$messageCode.I00000446.name}`
                ),
                defaultColor: '#0060C2',
                hidden: false,
              },
              {
                name: ' 送付状',
                widht: 'auto',
                type: 'plain',
                hover: '#0071EE',
                word: this.$t(
                  `validateMessage.${this.$messageCode.I00000446.name}`
                ),
                defaultColor: '#0060C2',
                hidden: false,
              },
            ],
          },
          {
            title: 'PS課発送日（プラス）毎週水曜発送',
            buttonList: [
              {
                name: ' 副本発送一覧',
                widht: 'auto',
                type: 'plain',
                hover: '#0071EE',
                word: this.$t(
                  `validateMessage.${this.$messageCode.I00000446.name}`
                ),
                defaultColor: '#0060C2',
                hidden: false,
              },
              {
                name: ' プラスにトラ一覧',
                widht: 'auto',
                type: 'plain',
                hover: '#0071EE',
                word: this.$t(
                  `validateMessage.${this.$messageCode.I00000446.name}`
                ),
                defaultColor: '#0060C2',
                hidden: false,
              },
            ],
          },
        ],
      }
    },
    methods: {
      show() {
        this.visibleChildren = true
      },
      update() {},
      close() {
        this.dialogVisible = false
        this.$emit('update:visibleDay', false)
      },
      //カレンダーデータを取得する
      async getCalendarList(data) {
        let res = await calendarSure(data)
        if (res?.length && res.length > 0) {
          this.$nextTick(() => {
            this.$refs.calendar.getTimes(data?.requestYearMonth).then(() => {
              this.$refs.calendar.setPageData(data)
              let daysList = resetCalender.call(
                this,
                this.getDateList(this.resetCalenderList),
                res
              )
              const dateList = crossDaySet(daysList, data?.requestYearMonth)
              this.$refs.calendar.setCalenderTime(dateList, this)
            })
          })
        }
      },
      getDateList(list) {
        return list
      },
      setParamsData(data) {
        this.paramsData = data
        this.dialogVisible = true
        this.resetCalenderList = data?.resetCalenderList
        let params = {
          requestYearMonth: this.formatDateTime(
            this.$baseLodash.toString(data.workYm),
            this.$const.dateFormatYYYYMMDD
          ),
          buildingCd: data.buildingCd,
          sectionCd: data.sectionCd,
          weekdayConditionSpecifyModel: data.weekdayConditionSpecifyModel,
          weekdayConditionSpecifySpotModel:
            data.weekdayConditionSpecifySpotModel,
          purchaseOrderDepCd:
            data.workingPlanAndResultIdModel?.purchaseOrderDepCd ||
            data.purchaseOrderDepCd,
        }

        console.log('params', params)
        this.getCalendarList(params)
      },
    },
  }
</script>

<style lang="scss" scoped>
  * {
    line-height: 150%;
  }
  .row_box {
    .vab_picker ::v-deep .el-input {
      width: 140px;
    }

    .vab_picker ::v-deep .el-form-item--mini.el-form-item {
      display: flex !important;
    }

    .clo_right_span {
      color: #000000;
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      width: 70px;
      margin-right: 34px;
    }

    .clo_textarea {
      width: auto;
      margin-left: 104px !important;
    }

    .textarea_span {
      padding-top: 8px;
      float: left;
    }
  }

  .el_dialog ::v-deep .el-dialog__title {
    font-family: 'Noto Sans JP';
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 150%;
    color: #003350;
  }

  .split_line {
    width: 4px;
    height: 20px;
    background: #003350;
    flex: none;
    order: 0;
    flex-grow: 0;
  }

  .box_title {
    font-family: 'Noto Sans JP';
    font-style: normal;
    font-weight: 700;
    font-size: 14px;
    color: #003350;
    flex: none;
    order: 1;
    flex-grow: 0;
    margin-left: 8px;
  }
</style>
